"use strict";import{Table as e}from"./src/Table.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-table",e);
//# sourceMappingURL=sp-table.js.map
